var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5H2.5C2.10218 3.5 1.72064 3.65804 1.43934 3.93934C1.15804 4.22064 1 4.60218 1 5V13C1 13.3978 1.15804 13.7794 1.43934 14.0607C1.72064 14.342 2.10218 14.5 2.5 14.5H10.5C10.8978 14.5 11.2794 14.342 11.5607 14.0607C11.842 13.7794 12 13.3978 12 13V8",
    stroke: "#2E3978",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5L14.364 1.136M10 0.5H15V5.5",
    stroke: "#2E3978",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/ExportIcon.92a3788f1b0b261682931b6a268dd40a.svg";
export { ForwardRef as ReactComponent };